try {
  module.exports = require('sha3').SHA3Hash
} catch (err) {
  module.exports = require('./browser')
}



//////////////////
// WEBPACK FOOTER
// ./~/keccakjs/index.js
// module id = 1474
// module chunks = 0 1 2